// extracted by mini-css-extract-plugin
export default {"cLogo":"Logo_cLogo__4jbRM"};